import * as React from 'react';
import { navMenuItemStyle } from '../../styles/globalStyles';
import { useSidebarColors } from '../../styles/themeMode';

interface HoverableNavItemProps {
    children: React.ReactNode;
    onClick?: () => void;
    isSelected?: boolean;
    isDisabled?: boolean;
    style?: React.CSSProperties;
}

export const HoverableNavItem: React.FC<HoverableNavItemProps> = ({
    children,
    onClick,
    isSelected = false,
    isDisabled = false,
    style,
}) => {
    const sc = useSidebarColors();
    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <div
            style={{
                ...navMenuItemStyle,
                backgroundColor: isHovered || isSelected ? sc.dropdownHoverBg : sc.dropdownBg,
                ...(isDisabled && { opacity: 0.5, cursor: 'not-allowed' }),
                ...style,
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={isDisabled ? undefined : onClick}
        >
            {children}
        </div>
    );
};
